module.exports = __webpack_public_path__ + "img/@tmp_live_view.95e901d5.png";